import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import logo from './vijaya logo.png';
import { BASE_URL } from './Constants.js';

const Printk = () => {
  
  const { id } = useParams(); // Get employee ID from the URL
  const [employee, setEmployee] = useState(null); // Employee data
  const [employeeDetails, setEmployeeDetails] = useState([]); // Uniform details (array)
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const token = localStorage.getItem('authToken'); // Get auth token from localStorage
        if (!token) {
          throw new Error('No auth token found. Please log in.');
        }

        // Fetch basic employee data
        const employeeResponse = await fetch(`${BASE_URL}printk/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!employeeResponse.ok) {
          throw new Error(`Failed to fetch employee. Status: ${employeeResponse.status}`);
        }

        const employeeData = await employeeResponse.json();
        console.log('Basic Employee Data:', employeeData);
        setEmployee(employeeData.employee); // Set employee data

        // Fetch uniform details data (uniform details is now an array)
        const detailsResponse = await fetch(`${BASE_URL}printt/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!detailsResponse.ok) {
          throw new Error(`Failed to fetch employee details. Status: ${detailsResponse.status}`);
        }

        const detailsData = await detailsResponse.json();
        console.log('Uniform Details Data:', detailsData);
        setEmployeeDetails(detailsData.employee1); // Set uniform details (array)
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message); // Set error message
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchEmployeeData(); // Call the function to fetch data
  }, [id]); // Dependency array ensures this runs when `id` changes

  // Conditional render for loading, error, or missing employee data
  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  if (!employee || employeeDetails.length === 0) {
    return <p>No employee or uniform data found.</p>;
  }
  const numberToWords = (num) => {
    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];

    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const scale = ["", "Thousand", "Million", "Billion", "Trillion"];

    if (num === 0) return "Zero";

    let words = "";
    let scaleIndex = 0;

    while (num > 0) {
      let chunk = num % 1000;
      if (chunk > 0) {
        words = `${chunkToWords(chunk)} ${scale[scaleIndex]} ${words}`;
      }
      num = Math.floor(num / 1000);
      scaleIndex++;
    }

    return words.trim();

    // Convert a number less than 1000 to words
    function chunkToWords(num) {
      let chunkWords = "";

      if (num >= 100) {
        chunkWords += ones[Math.floor(num / 100)] + " Hundred ";
        num = num % 100;
      }

      if (num >= 20) {
        chunkWords += tens[Math.floor(num / 10)] + " ";
        num = num % 10;
      }

      if (num > 0) {
        chunkWords += ones[num] + " ";
      }

      return chunkWords.trim();
    }
  };
  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        margin: '20px auto',
        padding: '20px',
        maxWidth: '800px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
       <div style={{ textAlign: 'center', marginBottom: '20px' }}>
    <img
      src={logo}
      alt="VDC"
      style={{ maxWidth: '100%', height: 'auto' }}
    />
  </div>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#2c3e50' }}>
        Receipt
      </h1>

      <div style={{ marginBottom: '30px', lineHeight: '1.6' }}>
        {/* <p><strong>Employee Details:</strong></p> */}
        {(() => {
          const rawName = employee.candidate_name || '';
          const match = rawName.match(/^(.*?)\s*\((\d+)\)/);

          if (match) {
            const name = match[1].trim();
            const empCode = match[2];
            return (
              <>
                <p><strong>Employee Name:</strong> {name}</p>
                <p><strong>Employee Code:</strong> {empCode}</p>
              </>
            );
          } else {
            return <div><strong>Employee Name:</strong> {rawName}</div>;
          }
        })()}

        <p><strong>Mobile:</strong> {employee.mobile || 'N/A'}</p>
        <p><strong>Gender:</strong> {employee.gender || 'N/A'}</p>
        <p><strong>Department:</strong> {employee.department || 'N/A'}</p>
        <p><strong>Location:</strong> {employee.location || 'N/A'}</p>
        <p><strong>Date of Joining:</strong> {employee.date_of_join || 'N/A'}</p>
        <p><strong>Transaction No:</strong> {employee.utr_number || 'N/A'}</p>
        <p><strong>Payment Status:</strong> {employee.payment_status || 'N/A'}</p>
      </div>

      {/* Employee Uniform Details Table */}
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '30px',
          fontSize: '14px',
        }}
      >
        <thead>
          <tr>
            {['Sr. No', 'Dress Type', 'Size', 'Color', 'Unit Price', 'Quantity', 'Total'].map(
              (heading, index) => (
                <th
                  key={index}
                  style={{
                    border: '1px solid #ddd',
                    padding: '10px',
                    backgroundColor: '#f4f4f4',
                    textAlign: 'left',
                    color: '#34495e',
                  }}
                >
                  {heading}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {/* Render uniform details */}
          {employeeDetails && employeeDetails.length > 0 ? (
            employeeDetails.map((item, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{index + 1}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{item.uniform_type || 'N/A'}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{item.uniform_size || 'N/A'}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{item.uniform_color || 'N/A'}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{Math.trunc(item.unit_cost || 'N/A')}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{item.qty || 'N/A'}</td>
                <td style={{ border: '1px solid #ddd', padding: '10px' }}>{item.cost || 'N/A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '10px' }}>
                No uniform details available.
              </td>
            </tr>
          )}
          <tr style={{
            border: '1px solid #ddd',
            padding: '10px',
            backgroundColor: '#f4f4f4',
            textAlign: 'center',
            color: '#34495e',
          }}>
            <th

              colSpan={4}
            >
              Total
            </th>
            <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
              {Math.trunc(employeeDetails.reduce((sum, item) => sum + parseFloat(item.unit_cost || 0), 0).toFixed(2))}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
              {employeeDetails.reduce((sum, item) => sum + parseInt(item.qty || 0), 0)}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
              {Math.trunc(employeeDetails.reduce((sum, item) => sum + parseFloat(item.cost || 0), 0).toFixed(2))}
            </td>
          </tr>

        </tbody>
      </table>
      <div style={{ marginBottom: '30px', lineHeight: '1.6' }}>
        <p>
          <strong>Amount in Words:</strong> {numberToWords(Number(employee.cost))} Rupees Only
        </p>
        <p>
          <strong>Date and Time:</strong> {new Date().toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default Printk;
